import React from 'react';
import Icon from './icon'
import './notifications.css';

/*
class Drawer extends React.Component {

  handleClear = () => {
    ui.notifications = [];
  }

  render() {
    const state = ui.showNotifications ? 'open' : 'closed';
    return (
      <div className={`notifications ${state}`}>
        <main>
          {ui.notifications.map( item => {
            return <Notification key={item.id} {...item} />
          })}
        </main>
      </div>
    )
  }
}


class Notification extends React.Component {

  componentWillMount() {
    setTimeout( () => {
      ui.deleteNotification(this.props.id);
    }, 2000);
  }

  handleClose = () => {
    ui.deleteNotification(this.props.id)
  }

  render() {
    return (
      <div className="notification-card card">
        <Icon icon={this.props.icon}/>
        <main>
          <h1>{this.props.title}</h1>
          <h2>{this.props.message}</h2>
        </main>
        <Icon className="closer small" icon="close" clickable action={this.handleClose} />
      </div>
    )
  }
}

const ActivityToken = ({ icon='done', title='Title', message='activity message...'}) => {
  return (
    <div className="activity-token card">
      <Icon icon={icon}/>
      <main>
        <h2>{message}</h2>
      </main>
    </div>
  )
}
*/


class Notifications extends React.Component {

  state = {
    state : 'none' // none | some | off | paused | active
  }

  get iconName() {
    const iconName = this.state.state === 'some' ? 'notifications' : `notifications_${this.state.state}`
    return iconName;
  }

  render() {
    return (
      <Icon icon={this.iconName} clickable/>
    )
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/lib/components/notifications.js